import { Icon, forwardRef } from "@chakra-ui/react";
import * as React from "react";
export const SvgLowerLeftCornerIcon = forwardRef((props, ref) => {
  return /* @__PURE__ */ React.createElement(Icon, { ref, color: "foreground.secondary", fill: "none", focusable: "false", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { id: "Frame 536" }, /* @__PURE__ */ React.createElement("path", { d: "M4 1V6C4 7.65685 5.34315 9 7 9H12", id: "Vector 148", stroke: "currentColor", strokeLinecap: "round" })));
});
export default SvgLowerLeftCornerIcon;
